<template>
    <Loading :loading="loading" :inset="true" :text="$t('logging_in') + '...'">
        <form @submit.prevent="login()" class="relative flex flex-col gap-2">
            <Input type="text" name="email" :formComponentId="this.$.uid" :label="$t('email_adress')" v-model:value="user.email" autocomplete="email" />

            <div class="flex items-center">
                <Input
                    :type="showPasswordField"
                    name="password"
                    :formComponentId="this.$.uid"
                    :label="$t('account_password')"
                    v-model:value="user.password"
                    autocomplete="current-password"
                    class="flex-1"
                />

                <button
                    type="button"
                    aria-label="Toggle password visibility"
                    class="ml-2 text-gray-500 hover:text-gray-700"
                    @mousedown="showPasswordInputFieldValue(true)"
                    @mouseup="showPasswordInputFieldValue(false)"
                    @mouseleave="showPasswordInputFieldValue(false)"
                >
                    <i :class="showIconValue" />
                </button>
            </div>

            <div class="flex flex-col lg:flex-row justify-between items-center gap-2">
                <Checkbox name="remember" :formComponentId="this.$.uid" :label="$t('remember_me')" v-model:value="user.remember" class="my-4" />
                <slot name="section-0"></slot>
            </div>

            <div v-if="showLinks">
                <router-link :to="{ name: 'register' }" class="block underline mt-2">
                    {{ $t('account_state_false') }}
                </router-link>
                <router-link :to="{ name: 'forgot-password' }" class="block underline mt-2">
                    {{ $t('forgot_password') }}
                </router-link>
            </div>

            <slot name="section-1"></slot>

            <FormButton
                type="submit"
                class="my-6"
                id="form_login"
                :formComponentId="this.$.uid"
                styling="primary flex items-center gap-3"
                :value="$t('account_login')"
                :disabled="loading"
            >
                <FontAwesomeIcon
                    v-show="loading"
                    :icon="['fas', 'circle-notch']"
                    class="animate-spin text-white transition-all ease-in-out duration-300 w-0"
                    :class="loading ? 'w-10' : ''"
                />
            </FormButton>

            <slot name="section-2"></slot>
        </form>
    </Loading>
</template>

<script>
import UAParser from 'ua-parser-js';

export default {
    props: {
        showLinks: Boolean,
        redirectTo: {
            type: String,
            default: '/dashboard'
        }
    },

    data: () => ({
        user: {},
        loading: false,
        showPassword: false
    }),

    methods: {
        showPasswordInputFieldValue(value) {
            this.showPassword = value || false;
        },

        login() {
            this.$store.commit('error/unsetByComponentId', this.$.uid);
            this.loading = true;
            this.user.config = {
                componentId: this.$.uid,
                headers: this.getBrowserData()
            };
            this.$store
                .dispatch('user/login', this.user)
                .then((_) => {
                    this.loading = false;
                    this.$router.push(this.redirectTo);
                    this.$emit('loginSuccess');
                })
                .catch((_) => {
                    this.loading = false;
                });
        },

        getBrowserData() {
            const parser = new UAParser();
            const deviceData = parser.getResult();

            const browserData = {
                'x-language': navigator.language,
                'x-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
            };

            // load screen resolution
            if (window && window.screen && window.screen.width && window.screen.height) {
                browserData['x-resolution'] = `${window.screen.width}x${window.screen.height}`;
            }

            if (deviceData) {
                browserData['x-device-type'] = deviceData?.device_type || 'unknown';
                browserData['x-platform'] = deviceData?.os.name || 'unknown';
                browserData['x-platform-version'] = deviceData?.os.version || 'unknown';
                browserData['x-browser-name'] = deviceData?.browser.name || 'unknown';
                browserData['x-browser-version'] = deviceData?.browser.version || 'unknown';
            }
            return browserData;
        }
    },
    computed: {
        showPasswordField() {
            if (this.showPassword) {
                return 'text';
            } else {
                return 'password';
            }
        },
        showIconValue() {
            if (this.showPassword) {
                return 'fi fi-rs-crossed-eye';
            } else {
                return 'fi fi-rs-eye';
            }
        }
    }
};
</script>
